document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('#feedback-form');
  if (form)
    form.addEventListener('ajax:success', function (event) {
      const ref = event.detail;
      const xhr = ref[2];
      form.innerHTML = xhr.response;
    });
});
